import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Grid,
  Autocomplete,
  TextField,
  CircularProgress,
  duration,
  DialogActions,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { axiosConfig } from "../../axios/axiosConfig";
import toast from "react-hot-toast";
import FutureTable from "./FutureTable";
import PaginationControls from "../../components/Pagination/PaginationControls";
const initialFormData = {
  script_name: "",
  trade_symbol: "",
  symbol_id: null,
  symbol_name: "",
  lot_size: null,
  duration: "",
  expected_profit: "",
  trade_status: "",
  stop_loss: "",
  target_amount: "",
  expire_date: "",
  entry_price: "",
  trade_type: "BUY",
  duration: "",
  ltp: "",
  target_plans_id: [],
  consent_status: [],
};
const FutureManagement = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [symbols, setSymbols] = useState([]);
  const [loadingSymbols, setLoadingSymbols] = useState(false);
  const [expiryLoading, setExpiryLoading] = useState(false);
  const [expiryDate, setExpiryDate] = useState([]);
  const [loadingFutSymbol, setLoadingFutSymbol] = useState(false);
  const [subscriptionLoading, setSubcriptionLoading] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [futureTrades, setFutureTrades] = useState([]);
  const [futureTradesLoading, setFutureTradesLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const fetchSymbols = async () => {
    setLoadingSymbols(true);
    try {
      const res = await axiosConfig({
        method: "get",
        url: "/option-trade-symbol-list/",
        data: {},
      });

      setSymbols(res?.data?.response || []);
    } catch (err) {
      console.log("Error fetching symbols:", err);
      toast.error(
        err?.response?.data?.response ||
          err?.message ||
          "Failed to fetch symbols"
      );
    } finally {
      setLoadingSymbols(false);
    }
  };
  const fetchExpiryDates = async (symbolName) => {
    setExpiryLoading(true);
    try {
      const res = await axiosConfig({
        method: "post",
        url: "/optionchain/expirydate",
        data: { symbol: symbolName },
      });

      const dates = res?.data?.response || [];
      setExpiryDate(dates);

      if (dates.length > 0) {
        handleFormChange("expire_date", dates[0]);
      } else {
        handleFormChange("expire_date", "");
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.response ||
          err?.message ||
          "Failed to fetch expiry dates"
      );
      setExpiryDate([]);
    } finally {
      setExpiryLoading(false);
    }
  };

  const fetchFutureSymbols = async (symbol, expiry) => {
    setLoadingFutSymbol(true);
    try {
      const res = await axiosConfig({
        method: "get",
        url: "/create-fut-symbol-with-lot",
        params: {
          symbol,
          expiry,
        },
      });

      const data = res?.data?.response;

      if (data) {
        handleFormChange("trade_symbol", data.symbol || "");
        handleFormChange("lot_size", data.lot || "");
        handleFormChange("ltp", data.ltp || "");
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.response ||
          err?.message ||
          "Failed to fetch expiry dates"
      );
    } finally {
      setLoadingFutSymbol(false);
    }
  };

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const fetchSubscriptionPlans = async () => {
    setSubcriptionLoading(true);
    try {
      const response = await axiosConfig({
        method: "get",
        url: "/subscription/subscription_plan",
      });
      const plansArray =
        response?.data?.response?.plans?.flatMap((p) => p.data || []) || [];
      setSubscriptionPlan(plansArray);
    } catch (error) {
      const errMsg =
        error.response?.data?.response ||
        error.message ||
        "Something went wrong.";
      toast.error(errMsg);
    } finally {
      setSubcriptionLoading(false);
    }
  };

  const handleTradeSubmit = async () => {
    if (submitLoading) return;

    setSubmitLoading(true);
    try {
      const payload = {
        daily_trade_symbol: null,
        script_name: formData.script_name,
        trade_symbol: formData.trade_symbol,
        symbol_id: Number(formData.symbol_id),
        symbol_name: formData.symbol_name,

        lot_size: Number(formData.lot_size),
        duration: formData.duration,
        // expected_profit: "0.00",
        // trade_status: "INACTIVE",

        stop_loss: String(formData.stop_loss),
        target_amount: String(formData.target_amount),
        expire_date: formData.expire_date,
        entry_price: String(formData.entry_price),
        trade_type: formData.trade_type,

        target_plans_id: formData.target_plans_id,
        // consent_status: formData.consent_status.length
        //   ? formData.consent_status
        //   : ["ENABLED", "NEVERENABLED", "CANCELLED"],
      };

      await axiosConfig({
        method: "post",
        url: "/future-signal-trade",
        data: payload,
      });
      toast.success("Future trade created successfully ✅");
      setOpenDialog(false);
      setFormData(initialFormData);
      await futureSignalTrades()
    } catch (error) {
      toast.error(
        error?.response?.data?.response ||
          error?.message ||
          "Failed to create trade"
      );
    } finally {
      setSubmitLoading(false);
    }
  };

  const futureSignalTrades = async () => {
    setFutureTradesLoading(true);
    try {
      const response = await axiosConfig({
        method: "get",
        url: `/future-signal-trade`,
        params: {
          page: page,
        },
      });
      console.log(response?.data, "response");
      const trade = response?.data || [];
      setFutureTrades(trade?.results?.response || []);
      setTotalCount(trade?.count);
    } catch (error) {
      const errMsg =
        error.response?.data?.response ||
        error.message ||
        "Something went wrong.";
      toast.error(errMsg);
    } finally {
      setFutureTradesLoading(false);
    }
  };

  useEffect(() => {
    if (formData.symbol_name && formData.expire_date) {
      fetchFutureSymbols(formData.symbol_name, formData.expire_date);
    }
  }, [formData.symbol_name, formData.expire_date]);

  useEffect(() => {
    fetchSymbols();
  }, []);

  useEffect(() => {
    fetchSubscriptionPlans();
  }, []);
  useEffect(() => {
    futureSignalTrades();
  }, [page]);
  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
          p: "20px 28px",
          mb: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <ShowChartIcon sx={{ color: "#fff", fontSize: 32 }} />
          <Box>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
              Future Trade Management
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
              Create and manage future signal trades
            </Typography>
          </Box>
        </Box>
        <Button
          onClick={() => setOpenDialog(true)}
          sx={{
            background: "linear-gradient(135deg, #016551, #014d3d)",
            color: "#fff",
            fontWeight: 600,
            borderRadius: "8px",
            px: 3,
            boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
            "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)" },
          }}
        >
          Add Future Trade
        </Button>
      </Box>

      {/* Table Card */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          overflow: "hidden",
          mb: 2,
        }}
      >
        <FutureTable
          rows={futureTrades}
          futureTradesLoading={futureTradesLoading}
          refresh={futureSignalTrades}
        />
      </Box>

      <PaginationControls
        totalCount={totalCount}
        page={page}
        setPage={setPage}
        offset={2}
      />

      {/* Add Future Trade Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: { borderRadius: "12px" } }}
      >
        <DialogTitle
          sx={{
            background: "#04343a",
            color: "#fff",
            fontWeight: 700,
            fontSize: "18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 2,
          }}
        >
          Add Future Trade
          <IconButton onClick={() => setOpenDialog(false)} size="small" sx={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Autocomplete
                freeSolo
                options={["Hero Zero (High Risk)", "High Risk"]}
                value={formData.script_name || ""}
                onChange={(_e, newValue) =>
                  handleFormChange("script_name", newValue || "")
                }
                onInputChange={(_e, newInputValue) =>
                  handleFormChange("script_name", newInputValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      formData.script_name &&
                      !["Hero Zero (High Risk)", "High Risk"].includes(
                        formData.script_name
                      )
                        ? "Adding Custom Script Name"
                        : "Script Name"
                    }
                    placeholder="Select or type custom"
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={symbols || []}
                loading={loadingSymbols}
                getOptionLabel={(o) => o?.name || ""}
                value={
                  formData.symbol_id
                    ? symbols.find((s) => s.symbol_id === formData.symbol_id) ||
                      null
                    : null
                }
                onChange={async (_e, newValue) => {
                  if (newValue?.is_banned) {
                    toast.error(`${newValue.name} is banned! 🚫`);
                    return;
                  }

                  handleFormChange("symbol_id", newValue?.symbol_id || null);
                  handleFormChange("symbol_name", newValue?.name || "");
                  //   handleFormChange("lot_size", newValue?.lot_size || "");

                  //   future use (expiry fetch etc.)
                  if (newValue?.name) {
                    await fetchExpiryDates(newValue.name);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Symbol"
                    fullWidth
                    required
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingSymbols && <CircularProgress size={18} />}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={expiryDate}
                loading={expiryLoading}
                value={formData.expire_date || null}
                onChange={(_e, newValue) =>
                  handleFormChange("expire_date", newValue || "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Expiry Date"
                    fullWidth
                    required
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {expiryLoading && <CircularProgress size={18} />}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Trade Symbol"
                value={formData.trade_symbol ?? ""}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                label="Lot"
                value={formData.lot_size ?? ""}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                label="LTP"
                value={formData.ltp ?? ""}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={["BUY", "SELL"]}
                value={formData.trade_type ?? ""}
                onChange={(_e, newValue) =>
                  handleFormChange("trade_type", newValue || "BUY")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Trade Type"
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Entry Price"
                type="number"
                value={formData.entry_price ?? ""}
                onChange={(e) =>
                  handleFormChange("entry_price", e.target.value)
                }
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                label="Duration"
                placeholder="1 day, 1-2 days"
                value={formData.duration ?? ""}
                onChange={(e) => handleFormChange("duration", e.target.value)}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Stop Loss"
                type="number"
                value={formData.stop_loss ?? ""}
                onChange={(e) => handleFormChange("stop_loss", e.target.value)}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Target Amount"
                type="number"
                value={formData.target_amount ?? ""}
                onChange={(e) =>
                  handleFormChange("target_amount", e.target.value)
                }
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                multiple
                options={subscriptionPlan}
                loading={subscriptionLoading}
                disableCloseOnSelect
                getOptionLabel={(option) => option?.name || ""}
                // ✅ value = objects derived from ids
                value={subscriptionPlan.filter((plan) =>
                  formData.target_plans_id.includes(plan.id)
                )}
                // ✅ onChange = store only ids
                onChange={(_e, selectedOptions) => {
                  handleFormChange(
                    "target_plans_id",
                    selectedOptions.map((opt) => opt.id)
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Target Subscription Plans"
                    placeholder="Select plans"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {subscriptionLoading && (
                            <CircularProgress size={18} />
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setOpenDialog(false)}
            sx={{ color: "#64748b", fontWeight: 600 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleTradeSubmit}
            disabled={submitLoading}
            sx={{
              background: "linear-gradient(135deg, #016551, #014d3d)",
              color: "#fff",
              fontWeight: 600,
              borderRadius: "8px",
              px: 4,
              "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)" },
              "&:disabled": { background: "#ccc" },
            }}
          >
            {submitLoading ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Submit Trade"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FutureManagement;
